module.exports = __webpack_public_path__ + "static/media/pattern-yellow-background.1364c018.svg";